module.exports = __webpack_public_path__ + "static/media/publish-modal-bg.7e872606.png";